import React, { useEffect, useRef, useState } from 'react';
import { Field, Formik, Form as FormFormik } from 'formik';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import useStyles from './styles';
import { OutlineTextField } from '../../../../FormikCustoms';

const validateForm = (values, hasQueueOrder, hasError) => {
  const errors = {};

  if (!values.driver_phone_number) {
    errors.driver_phone_number = "Telefone motorista é necessário.";
  }

  if (hasQueueOrder && !values.queue_order) {
    errors.queue_order = "Senha é necessária.";
  }

  return errors;
};

const Form = ({ hasQueueOrder, onSubmit }) => {

  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [buttonSize, setButtonSize] = useState(0);
  const buttonRef = useRef(null);

  useEffect(() => {
    const { clientHeight, clientWidth } = buttonRef.current;
    setButtonSize(Math.min(clientHeight, clientWidth));
  }, []);

  const handleConfirm = async (values, actions) => {
    setLoading(true);
    try {
      const res = await onSubmit(values);
      if(res.success === false) {
        actions.setFieldError('driver_phone_number', 'Verifique o número.');
        if(values?.driver_additional_phone_number) {
          actions.setFieldError('driver_additional_phone_number', 'Verifique o número.');
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      throw(e);
    }
  };

  return (
    <Formik
    enableReinitialize
      initialValues={{
        driver_phone_number: '',
        driver_additional_phone_number: '',
        queue_order: null,
      }}
      validate={(values) => validateForm(values, hasQueueOrder)}
      onSubmit={(values, actions) => handleConfirm(values, actions)}
    >
      {({ submitForm, isSubmiting, values }) => (
        <FormFormik>
          <Grid container direction="column">
            <Grid item={true}>
              <Field
                component={OutlineTextField}
                variant="outlined"
                type="text"
                inputmode="tel"
                label="Telefone motorista"
                mask="(99)99999-9999"
                maskPlaceholder=""
                required
                name="driver_phone_number"
                value={values.driver_phone_number}
              />
            </Grid>

            <Grid item={true} style={{ paddingTop: 20 }}>
              <Field
                component={OutlineTextField}
                variant="outlined"
                type="text"
                inputmode="tel"
                mask="(99)99999-9999"
                maskPlaceholder=""
                label="Telefone adicional"
                name="driver_additional_phone_number"
                value={values.driver_additional_phone_number}
              />
            </Grid>

            {hasQueueOrder && (
              <Grid item={true} style={{ paddingTop: 20 }}>
                <Field
                  component={OutlineTextField}
                  variant="outlined"
                  type="text"
                  mask="9999999999"
                  label="Senha"
                  required
                  name="queue_order"
                  value={values.queue_order}
                />
              </Grid>
            )}

            <Grid item={true} style={{ paddingTop: 20 }}>
              <Button
                ref={buttonRef}
                color="primary"
                variant="contained"
                size="large"
                className={classes.btns}
                disabled={isSubmiting || loading}
                onClick={submitForm}
              >
                {loading ? <CircularProgress size={0.7 * buttonSize} /> : 'Salvar'}
              </Button>
            </Grid>
          </Grid>
        </FormFormik>
      )}
    </Formik>
  );
};

export default Form;
